import LessonCreationModal from './LessonCreationModal';

export default LessonCreationModal;
